<template>
  <div class="account-service-wrap">
    <div class="row row-header">
      <div class="col-xs-12 col-md-2">
        Užsakymo numeris
      </div>
      <div class="col-xs-12 col-md-5 text-left">
        Užsakyta paslauga
      </div>
      <div class="col-xs-12 col-md-1">
        Kaina
      </div>
      <div class="col-xs-12 col-md-1"></div>
      <div class="col-xs-12 col-md-1">
        Būsena
      </div>
      <div class="col-xs-12 col-md-2 text-right">Veiksmai</div>
    </div>
    <div
      class="row row-service"
      v-for="(service, index) in services.data"
      :key="service.id"
    >
      <div class="col-xs-12 col-md-2">
        <div class="dash-reference">
          {{ service.reference ? service.reference : '-' }}
        </div>
        <div class="dash-placed-at">{{ service.placed_at }}</div>
      </div>
      <div class="col-xs-12 col-md-5 text-left">
        {{ service.name }}
      </div>
      <div class="col-xs-12 col-md-1 text-right">
        <template v-if="!service.user_price_enabled">
          <template v-if="service.price && service.paid_service">
            {{ service.price / 100 }} {{ service.currency }}
          </template>
          <template v-else>
            Nemokama
          </template>
        </template>
        <template v-else>
          {{ service.price_user / 100 }} {{ service.currency }}
        </template>
      </div>
      <div class="col-xs-12 col-md-1">
        <template v-if="service.order_status == 'payment-received'">
          <span>
            <span class="badge badge-payment_received">Apmokėta</span>
          </span>
        </template>
      </div>
      <div class="col-xs-12 col-md-1">
        <template v-if="service.order_status == 'pending'">
          <span v-html="statusRender('payment_pending')"></span>
        </template>
        <template v-else-if="service.init_pay && !service.payment_received">
          <span v-html="statusRender('payment_pending')"></span>
        </template>
        <template v-else>
          <span v-html="statusRender(service.status)"></span>
        </template>
      </div>
      <div class="col-xs-12 col-md-2 text-right">
        <button
          v-b-tooltip.hover
          title="Apmokėti"
          class="btn-action btn-action-pay"
          @click="addServiceToCart(service)"
          v-if="service.init_pay && !service.payment_received"
        >
          <i class="fas fa-cart-plus"></i>
        </button>
        <a
          :href="`/account/services/${service.id}/submit-review`"
          v-b-tooltip.hover
          :title="$t('buttons.preview')"
          class="btn-action btn-action-preview"
        >
          <i class="fas fa-eye"></i>
        </a>
        <a
          :href="`/account/services/${service.id}/edit`"
          v-b-tooltip.hover
          :title="$t('buttons.edit')"
          class="btn-action btn-action-edit"
          v-if="!service.locked"
        >
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a
          :href="`/account/services/${service.id}/delete-record`"
          class="btn-action btn-action-delete"
          v-b-tooltip.hover
          :title="$t('buttons.delete')"
          v-confirm="{
            html: true,
            okText: 'Trinti',
            cancelText: 'Atšaukti',
            message: `Ar tikrai norite ištrinti paslaugos <strong>${service.name}</strong> įrašą ?`,
            animation: 'zoom'
          }"
          v-if="!service.locked && service.status != 'revise'"
        >
          <i class="fas fa-trash-alt"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountServices',
  title: '',
  components: {},
  props: {
    services: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selected: [],
      window: {
        width: 0,
        height: 0
      },
      icons: {
        opened: '<i class="fas fa-chevron-up"></i>',
        closed: '<i class="fas fa-chevron-down"></i>'
      }
    }
  },
  computed: {},
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted() {},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    addServiceToCart(form) {
      this.$store.dispatch('basket/addToBasket', {
        record_type: 'record_pay',
        record_id: form.fid,
        code: form.service_id,
        name: form.name,
        quantity: 1,
        price:
          form.user_price_enabled && form.price_user
            ? form.price_user
            : form.price,
        line_total: 1
      })
      this.$emit('close')
    },
    statusRender(status) {
      return (
        '<span class="badge badge-' +
        status +
        '">' +
        this.$t('services.status.' + status) +
        '<span>'
      )
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight - 50
    },
    toggleShowFilters() {}
  }
}
</script>
